<app-loading />
<div class="loyalty-shell pos-relative w-100">
   <main class="pageWraper">
      <router-outlet />
   </main>
</div>
